
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.71 10.499L8.763 1.407C7.969.07 6.032.068 5.236 1.407L.291 10.5c-.812 1.367.171 3.097 1.763 3.097h9.891c1.591 0 2.576-1.73 1.764-3.097zM7 11.956a.821.821 0 010-1.64.821.821 0 010 1.64zm.82-3.281a.821.821 0 01-1.64 0V4.573a.821.821 0 011.64 0v4.102z","fill":"#FF5757"}})])
          )
        }
      }
    